export default __webpack_public_path__ + "static/media/furniture13.3cbd3cb7.jpeg";